import { styled } from '../../styles'

export const PagePadding = styled('div', {
  padding: '16px 24px'
})